import { UPDATE_DEVICE_ID } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_DEVICE_ID:
            return action.payload
        default:
            return state
    }
}
